import { render } from "./SalesView.vue?vue&type=template&id=19bf1a6f"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__